import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { useHistory, withRouter, Link } from "react-router-dom"

import { getToken, IsModemAccess } from '../../helpers/helper';
import { del, post } from '../../helpers/api_helper';
import { POST_OFFERWALL_LIST, DELETE_OFFERWALL, POST_UPDATE_OFFERWALL_STATUS } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"


const UserProfile = props => {
    let history = useHistory();
    const [offerwall_id, SetOfferwallId] = useState(0);

    useEffect(() => {
        get_list();
    }, [])

    // get list
    const get_list = () => {
        $(document).ready(function () {
            $('#dataTableExample').DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": true,
                "sServerMethod": "POST",
                "sAjaxSource": POST_OFFERWALL_LIST,
                "order": [[0, 'desc']],
                columnDefs: [{ orderable: false, targets: [5,6] }, { "targets": 0, "visible": false }],
                "fnServerData": function (sSource, aoData, fnCallback) {
                    $.ajax({
                        "dataType": 'json',
                        "type": "POST",
                        "url": sSource,
                        "data": aoData,
                        "success": fnCallback,
                        headers: { 'Authorization': getToken() },
                    });
                },
                "columns": [
                    { "data": "id" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                    <img alt="Banner" src={data.image}  style={{'maxWidth': '70px','border-radius': '0px','height':'auto','width':'100%'}}/>
                            </>, td)
                        }
                    },
                    { "data": "network" }, 
                    { "data": "network_type" },
                    { "data": "ad_format" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {data.status === 1 && <button onClick={UpdateStatus.bind(this, data.id, data.status)} className="border-0 badge badge-success fs-6"  >Active</button>}
                                {data.status === 0 && <button onClick={UpdateStatus.bind(this, data.id, data.status)} className="border-0 badge badge-danger fs-6" >Deactive</button>}
                            </>, td)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {IsModemAccess('offerwall', 'edit') && <button className="btn btn-soft-success waves-effect waves-light p-1 mr-2" onClick={() => { history.push('/edit-offerwall/' + data.id); }} ><i className="bx bx-edit align-middle"></i></button>}
                                {IsModemAccess('offerwall', 'delete') && <button className="btn btn-soft-danger waves-effect waves-light p-1 mr-2" onClick={() => { SetOfferwallId(data.id); }} data-toggle="modal" data-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>}
                            </>, td)
                        }
                    },
                ]
            });
        });
    }

    // remove
    const remove_row = async () => {
        var res_data = await del(DELETE_OFFERWALL + "?offerwall_id=" + offerwall_id);
        if (res_data.status) {
            toast(res_data.message);
            get_list();
        } else {
            toast.error(res_data.message);
        }
    }

    //UpdateStatus
    const UpdateStatus = async (offerwall_id, status) => {
        if (!IsModemAccess('offerwall', 'edit')) {
            toast('Does not permission this module');
            return true;
        }
        var res_data = await post(POST_UPDATE_OFFERWALL_STATUS, { offerwall_id: offerwall_id, status: status });
        if (res_data.status) {
            toast(res_data.message);
            get_list();
        } else {
            toast.error(res_data.message);
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Offerwall | Free Money Coins</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumb title="Dashboard" breadcrumbItem="Offerwall" />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h5>Offerwall List</h5>
                                        </div>
                                        <div className="col-sm-6 text-end">
                                            {IsModemAccess('offerwall', 'add') && <Link to="/add-offerwall" className="btn btn-primary btn-sm w-xs">+ Add</Link>}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="mt-4 mb-5">
                                        {IsModemAccess('offerwall', 'view') && <table id="dataTableExample" className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td>Id</td>
                                                    <td>Image</td>
                                                    <td>Network</td>
                                                    <td>Type</td>
                                                    <td>Format</td>
                                                    <td>Status</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>

    )
}

export default withRouter(UserProfile)
